import { render } from "./logo.svg?vue&type=template&id=538ed6b6"
const script = {}
script.render = render

export default script